module.exports = __webpack_public_path__ + "img/20220623154847402dx9.159b0a72.jpg";